export default class TimelineBlock {
    constructor (
        status,
        startTime,
        endTime,
        startAddress,
        endAddress,
        deviceId,
        journeyId,
        journeyType
    ) {
        this.status = status
        this.startTime = startTime
        this.endTime = endTime
        this.startAddress = startAddress
        this.endAddress = endAddress
        this.deviceId = deviceId
        this.journeyId = journeyId
        this.journeyType = journeyType
    }
}
